export default __webpack_public_path__ + "static/media/pic3.7724a4c6.jpg";